import { useTranslation } from 'react-i18next';

export default function AuroraFeesSection() {
  const { t } = useTranslation();
  
  return (
    <section className="py-16 bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {t('aurora.fees.title')}
          </h2>
          <p className="text-xl text-gray-300">
            {t('aurora.fees.subtitle')}
          </p>
        </div>

        <div className="bg-gray-900 rounded-xl overflow-hidden border border-gray-700">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-purple-900">
                <tr>
                  <th className="py-4 px-6 text-left text-white font-semibold">{t('aurora.fees.item')}</th>
                  <th className="py-4 px-6 text-left text-white font-semibold">{t('aurora.fees.fee')}</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-700">
                <tr className="hover:bg-gray-800 transition-colors">
                  <td className="py-4 px-6 text-gray-300 font-semibold">{t('aurora.fees.issuance')}</td>
                  <td className="py-4 px-6 text-white text-lg">300USDT</td>
                </tr>
                <tr className="hover:bg-gray-800 transition-colors">
                  <td className="py-4 px-6 text-gray-300 font-semibold">{t('aurora.fees.deposit')}</td>
                  <td className="py-4 px-6 text-white text-lg">1.3%</td>
                </tr>
                <tr className="hover:bg-gray-800 transition-colors">
                  <td className="py-4 px-6 text-gray-300 font-semibold">{t('aurora.fees.annual')}</td>
                  <td className="py-4 px-6 text-white text-lg">
                    15USDT
                    <span className="text-sm text-gray-400 ml-2">{t('aurora.fees.annual.note')}</span>
                  </td>
                </tr>
                <tr className="hover:bg-gray-800 transition-colors">
                  <td className="py-4 px-6 text-gray-300 font-semibold">{t('aurora.fees.atmWithdrawal')}</td>
                  <td className="py-4 px-6 text-white text-lg">
                    8%
                    <span className="text-sm text-gray-400 ml-2">{t('aurora.fees.atmWithdrawal.note')}</span>
                  </td>
                </tr>
                <tr className="hover:bg-gray-800 transition-colors">
                  <td className="py-4 px-6 text-gray-300 font-semibold">{t('aurora.fees.atmLimit')}</td>
                  <td className="py-4 px-6 text-white text-lg">
                    {t('aurora.fees.atmLimit.value')}
                    <span className="text-sm text-gray-400 ml-2">{t('aurora.fees.atmLimit.note')}</span>
                  </td>
                </tr>
                <tr className="hover:bg-gray-800 transition-colors">
                  <td className="py-4 px-6 text-gray-300 font-semibold">{t('aurora.fees.depositLimit')}</td>
                  <td className="py-4 px-6 text-green-400 text-lg font-bold">{t('aurora.fees.unlimited')}</td>
                </tr>
                <tr className="hover:bg-gray-800 transition-colors">
                  <td className="py-4 px-6 text-gray-300 font-semibold">{t('aurora.fees.paymentLimit')}</td>
                  <td className="py-4 px-6 text-green-400 text-lg font-bold">
                    {t('aurora.fees.unlimited')}
                    <span className="text-sm text-gray-400 ml-2">{t('aurora.fees.paymentLimit.note')}</span>
                  </td>
                </tr>
                <tr className="hover:bg-gray-800 transition-colors">
                  <td className="py-4 px-6 text-gray-300 font-semibold">{t('aurora.fees.transaction')}</td>
                  <td className="py-4 px-6 text-white text-lg">5%</td>
                </tr>
                <tr className="hover:bg-gray-800 transition-colors">
                  <td className="py-4 px-6 text-gray-300 font-semibold">{t('aurora.fees.brand')}</td>
                  <td className="py-4 px-6 text-white text-lg">Mastercard</td>
                </tr>
                <tr className="hover:bg-gray-800 transition-colors">
                  <td className="py-4 px-6 text-gray-300 font-semibold">{t('aurora.fees.japanUse')}</td>
                  <td className="py-4 px-6 text-green-400 text-lg font-bold">
                    <i className="ri-check-line text-2xl"></i> {t('aurora.fees.available')}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="mt-8 bg-blue-900/20 border border-blue-700 rounded-xl p-6">
          <p className="text-blue-300 flex items-start">
            <i className="ri-information-line text-2xl mr-3 mt-1"></i>
            <span>{t('aurora.fees.info')}</span>
          </p>
        </div>
      </div>
    </section>
  );
}